// CART MIXIN
export const CartMixin = {
   computed: {
      /**
       * Handles the 'menuQuantity' custom field's v-model so it interacts with Vuex.
       */
      menuQuantity: {
         get () {
            return this?.lineItems?.menus?.quantity ?? window.mymy.menu.quantity.min;
         },
         set (value) {
            this.$store.commit('updateMenuLineItemQuantity', value);
         }
      },
   },
   methods: {
      /**
       * Remove a line item from the order summary.
       *
       * @param variantId {number}
       */
      removeLineItem(variantId) {
         // get the MenuItem vue component
         let MenuItemControls = this.getMenuItemComponent(variantId);
         if (!MenuItemControls) {
            return;
         }

         // reduce the quantity to 0 and let the component speak to the Vuex store via its
         // watcher
         MenuItemControls.quantity = 0;

         // close the mobile summary modal if the customer isn't on desktop
         this.modals.mobileSummary.show = false;
      },

      /**
       * Remove a dish from a course in a package menu.
       *
       * If the customer is trying to remove a dish from a course prior to the one they're
       * on, then this will alert them, and upon their confirmation that they do indeed
       * want to remove it, it will do so and take them back to that course so they can
       * fulfill the minimum number of items required for that course.
       *
       * @param variantId {number}
       * @param force {boolean}
       */
      removeCourseItem(variantId, force = false) {
         // get the MenuItemControls vue component
         let MenuItemControls = this.getMenuItemComponent(variantId);
         if (!MenuItemControls) {
            return;
         }

         // if they are trying to remove an item from a previous course, then log the
         // menu item, which will show them the modal first.
         if (this.sectionIndex > MenuItemControls.sectionIndex && !force) {
            let MenuSection = this.getSection(MenuItemControls.sectionIndex);
            this.modals.courseWarning.requiredMinimum = MenuSection.minimumRequired;
            this.modals.courseWarning.title = MenuSection.title;
            this.modals.courseWarning.variantId = variantId;
            this.modals.courseWarning.show = true;
            return;
         }

         // reduce the `courseDishQuantity` to 0 and let the component speak to the Vuex store
         // via its watcher
         MenuItemControls.courseDishQuantity = 0;

         // reset the variant ID
         this.modals.courseWarning.variantId = null;
         this.modals.courseWarning.show = false;

         // close the mobile summary modal if the customer isn't on desktop
         this.modals.mobileSummary.show = false;

         if (force) {
            this.navigateToSection(MenuItemControls.sectionIndex);
         }
      },
   },
};